import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import './styles/tokens.css';

const el = document.getElementById('root');
if (!el) throw new Error('#root 未找到');

createRoot(el).render(
  <StrictMode>
    <App />
  </StrictMode>,
);

/**
 * 注册 Service Worker（仅生产构建）。
 *
 * 开发模式不注册：SW 会缓存旧模块，改代码后页面拿到的是缓存版本，
 * 排查问题时会看到「明明改了却没变化」。devServer 清缓存很烦人。
 */
if (import.meta.env.PROD && 'serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    void navigator.serviceWorker.register('/sw.js', { scope: '/' }).catch((err) => {
      // 注册失败不影响主流程（应用仍可用，只是没有离线外壳）
      console.warn('[pwa] service worker 注册失败', err);
    });
  });
}
